/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：60
 */

"use strict"

export { PROJECT as v }
export { r as b }
export { o as a }
export { i as c }
export { a as d }
export { c as t }
export { l as o }
export { u as l }
export { d as g }
export { p as u }
export { f as p }
export { h }
export { m }
export { g as e }
export { _ as n }
export { v as f }
export { b as k }
export { y as s }
export { E as r }
export { O as j }
export { w as q }
export { C as i }
var r
var o
var i
var a
var /* [auto-meaningful-name] */PROJECT = "PROJECT"
!function (e) {
  e[e.ByUser = 1] = "ByUser"
  e[e.AutoSave = 2] = "AutoSave"
}(r || (r = {}));
(function (e) {
  e.CENTER = "center"
  e.LEFT = "left"
  e.RIGHT = "right"
})(o || (o = {}));
(function (e) {
  e.FLEX_START = "flex-start"
  e.CENTER = "center"
  e.FLEX_END = "flex-end"
})(i || (i = {}));
(function (e) {
  e.NONE = "NONE"
  e.DRAG = "DRAG"
  e.CLICK = "CLICK"
})(a || (a = {}))
var c = 0
var l = 0
var u = 1 / 0
var d = 1 / 0
var p = 20
var f = 20
var h = 999999999
var m = 999999999
var g = 1 / 0
var _ = 12
var v = 9999
var b = 999999999
var y = -99999999
var E = 0
var O = 100
var w = -99999999
var C = 999999999
export default o
